<template>
    <div class="tw-container">
        <h1 class="tw-text-3xl">
            Heaven Userdaten Import
        </h1>

        <hr class="tw-my-4">

        <div class="tw-bg-danger-secondary tw-rounded-lg tw-p-4 tw-text-danger-primary tw-mb-4" v-if="errorMessage">
            <strong>
                Fehler
            </strong>

            <ul class="tw-mt-2">
                <li v-text="errorMessage"></li>
            </ul>
        </div>

        <div class="tw-bg-info-secondary tw-rounded-lg tw-p-4 tw-text-info-primary tw-mb-4" v-if="output">
            <strong>
                Importstatus
            </strong>

            <ul class="tw-mt-2">
                <li v-text="output"></li>
            </ul>
        </div>

        Bitte lade eine CSV Datei zum importieren hoch.

        <input type="file" class="tw-mt-4" @change="onFileChanged">

        <button type="button" class="cu-btn tw-mt-4" @click="importFile" :disabled="loading">
            Daten importieren
        </button>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                file: null,
                loading: false,
                errorMessage: null,
                output: null,
            }
        },

        methods: {
            onFileChanged(e) {
                let files = e.target.files || e.dataTransfer.files;

                if (!files.length) {
                    return;
                }

                this.file = files[0];
            },

            importFile() {
                if (!this.file) {
                    alert('Bitte wähle eine CSV Datei zum importieren aus.');
                    return;
                }

                this.loading = true;
                this.output = null;
                this.errorMessage = null;
                let formData = new FormData();
                formData.append("csv_file", this.file);

                axios
                    .post('/admin/heaven-user-data-import', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        if (!! response.data.output) {
                            this.output = response.data.output;
                        }
                    })
                    .catch(error => {
                        if (!! error.response.data.errors && error.response.data.errors.length > 0) {
                            if (!! error.response.data.csv_file && error.response.data.csv_file.length > 0) {
                                this.errorMessage = error.response.data.csv_file[0];
                            }
                        }

                        if (! this.errorMessage && !! error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        }
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>